// src/components/courses/CoursesHero.jsx
import React from 'react';
import styles from './CoursesHero.module.css';
import coursesHeroBg from '../../assets/imgs/Bspark-Courses-Banner-1-02.jpg'; // Corrected import to the right image


const CoursesHero = () => {
  const handleScrollToCourses = () => {
    const section = document.getElementById('courseList');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

 return (
 <section className={styles.coursesHero} style={{ backgroundImage: `url(${coursesHeroBg})` }}>
 <div className={styles.heroContentContainer}>
 <div className={styles.heroContent}>
 <h1 className={styles.heroTitle}>Spark Your Learning Journey with Us</h1> 
 {/* //popup spark */}
 <p className={styles.heroSubtitle}>
 Tailored Software Development & Testing programs designed to upskill your workforce, boost productivity, and drive quality.
 </p><div>
  <button
            className={styles.heroCtaButton}
            onClick={handleScrollToCourses}
          >
            View All Courses
          </button>
           </div> 
 </div>
 <div className={styles.iconGrid}>
 {/* ICONS ARE PART OF THE BACKGROUND IMAGE, so no need for a separate icon grid component */}
 </div>
 </div>
 </section>
   );
};

export default CoursesHero;